import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import { useGetBloodType } from '@hooks/api/lab-result';
import { useGetLatestObservations } from '@hooks/api/observation';

import { TrackerType } from '@models/vital-sign';

import HealthTrackerMain from '../HealthTracker/Main';

const messages = defineMessages({
  title: {
    id: 'bodyMain.title',
    defaultMessage: 'Body',
  },
});

const BodyMain: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  const { data: bloodTypeObservation, loading: bloodTypeLoading } =
    useGetBloodType();
  const {
    data: {
      blood_sugar,
      body_height,
      body_weight,
      body_mass_index,
      muscle_mass,
      body_fat_percentage,
      body_chest_cm,
      body_waist_cm,
      body_hips_cm,
      body_thigh_cm,
      body_waist_hip,
      body_waist_height,
    },
    loading: latestObservationsLoading,
  } = useGetLatestObservations({
    blood_sugar: true,
    body_height: true,
    body_weight: true,
    body_mass_index: true,
    muscle_mass: true,
    body_fat_percentage: true,
    body_chest_cm: true,
    body_waist_cm: true,
    body_hips_cm: true,
    body_thigh_cm: true,
    body_waist_hip: true,
    body_waist_height: true,
  });

  const records = {
    blood_type: bloodTypeObservation ?? null,
    blood_sugar,
    body_height,
    body_weight,
    body_mass_index,
    muscle_mass,
    body_fat_percentage,
    body_chest_cm,
    body_waist_cm,
    body_hips_cm,
    body_thigh_cm,
    body_waist_hip,
    body_waist_height,
  };

  const loading = bloodTypeLoading || latestObservationsLoading;

  return (
    <HealthTrackerMain
      category={TrackerType.Body}
      loading={loading}
      records={records}
      title={formatMessage(messages.title)}
    />
  );
};

export default withErrorBoundary(BodyMain, {
  FallbackComponent: ErrorBoundaryFallback,
});
